export default "__VITE_ASSET__CqHNsdvp__"